var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadModsquare = function SvgFadModsquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.996 208A4 4 0 0 1 32 204.005V51.995A3.997 3.997 0 0 1 36.003 48h87.994a4.018 4.018 0 0 1 4.017 4.007l.472 135.486a4.05 4.05 0 0 0 4.01 4.032l71.507.45a3.971 3.971 0 0 0 3.997-3.977V52.002A3.999 3.999 0 0 1 211.996 48h8.008A4 4 0 0 1 224 51.995v152.01a3.992 3.992 0 0 1-4.003 3.995H116.003a4.004 4.004 0 0 1-4.003-4.002V68.002A4.004 4.004 0 0 0 107.997 64H52.003A4.005 4.005 0 0 0 48 68.002v135.996A3.999 3.999 0 0 1 44.004 208h-8.008z",
    stroke: "#979797",
    fillRule: "evenodd"
  })));
};
export { SvgFadModsquare as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-modsquare.b30c5fd7.svg";